const ENV = {
    START: 'start',
    DEV: 'dev',
    PRE: 'pre',
    ONLINE: 'build'
}

let baseUrl = '';
let indexFloorId = '';
const isHk = window.location.host.indexOf('jd.hk') !== -1;
switch (process.env.REACT_APP_ENV) {
    case ENV.DEV:
    case ENV.START:
        baseUrl = isHk ? 'http://beta-color.jd.hk/': 'http://beta-api.m.jd.com';
        indexFloorId = '207342';
        break;
    case ENV.PRE:
    case ENV.ONLINE:
        baseUrl = isHk ? '//color.jd.hk' : '//api.m.jd.com'
        indexFloorId = '54935149';
        break
    default:
        baseUrl = isHk ? '//beta-color.jd.hk' : '//beta-api.m.jd.com'
        indexFloorId = '207342';
        break;
}

// ------------------------------- baseUrl -------------------------------

export const COMMON_BASE_URL = baseUrl;
export const INDEX_FLOOR_ID = indexFloorId;

// ------------------------------- 接口 api -------------------------------

// export const FLOOR_QUERY_LIST = 'http://beta-api.m.jd.com/client.action?functionId=queryChannelData&appid=global_mart&tabId=&appId=207333&body=%7B%22applicationId%22:%22207333%22%7D';

export const MAIN_PAGE_DATA = `${COMMON_BASE_URL}/client.action?functionId=queryChannelData&appid=global_mart&client=pc&body=`

export const COMMON_JDW_REQUEST_URL = "/client.action"

export const QUERY_RECOMMEND = "https://diviner.jd.com/diviner";
export const QUERY_ADVERTISEMENT = "https://ad.3.cn/ads/mgets";
export const CKECK_CHAT = "https://chat1.jd.com/api/checkChat";
export const COMPAREDINFO = "https://fts.jd.com/ware/history";